import React, { Component } from 'react';
import './App.css';
import Loader from './containers/Loader/Loader';
import Generator from './containers/Generator/Generator';
import { Route, Switch } from 'react-router-dom';

class App extends Component {
  render() {
    return (
      <div>
        <Switch>
          <Route path="/generator" component={Generator} />
          <Route path="/" component={Loader} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js